import PageProtectedLayout from "../../components/Page/PageProtectedLayout";
import { useTranslation } from '../../language';
import PasswordChangeDashboard from "./PasswordChangeDashboard";


export default function PasswordChangeWelcome() {

  const { t } = useTranslation();

  return (

    <PageProtectedLayout
      headline={t('ua_pw_headline')}
      specify={t('ua_pw_subtext')}
    >

      <PasswordChangeDashboard />

    </PageProtectedLayout>

  );
}
